/* eslint-disable no-new */
/**
 THRU  - Admin Dashboard
 @page Components Index
 @description Index for pages router
*/

import Vue from 'vue';
import Router from 'vue-router';

//DASHBOARD PAGES
import Login from '@/router/Customer/Login.vue';
import BatteryPackList from '@/router/Customer/BatteryPackList.vue';
import CurrentStatus from '@/router/Customer/CurrentStatus.vue';
import Map from '@/router/Customer/Map.vue';

Vue.use(Router)

//ROUTER CONFIG
export default new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    },
    routes: [{
        path: '/',
        component: Login
    },
    {
        path: '/main_menu/battery_pack_list',
        name: 'battery_pack_list',
        component: BatteryPackList
    }, {
        path: '/main_menu/current_status',
        name: 'current_status',
        component: CurrentStatus
    }, {
        path: '/main_menu/map',
        name: 'Map',
        component: Map
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js